module.exports = __webpack_public_path__ + "static/img/营业执照(1).7fe7ee22.jpg";